<template>
  <div class="login-page" data-test="login__page">
    <InfoLink title="Si vous n'avez pas de compte ici, veuillez vous rediriger
                      vers l'application mon compte et suivre la proc�dure"
              :link="monCompteUrl"/>
    <Users :users="getAllUsers"
           :loading="loading"
           @authTry="loginWithCredentials($event)"></Users>
  </div>
</template>

<script>
  import Users from '../../components/Users/Users.vue';
  import InfoLink from '../../components/InfoLink/InfoLink.vue';

  export default {
    components: {
      Users,
      InfoLink,
    },
    data() {
      return {
        loading: true,
        monCompteUrl: `${process.env.VUE_APP_MON_COMPTE_URL}/magic-link-verification?token=${localStorage.getItem('shopToken')}`,
      };
    },
    mounted() {
      this.$store.dispatch('supplier/list', this.shopId);
      this.$store.dispatch('auth/CleanStore');
      return this.$store.dispatch('auth/GetAllUsers')
        .then(() => {
          this.loading = false;
        });
    },
    computed: {
      getAllUsers() {
        return this.$store.getters['auth/userList'];
      },
      apiState() {
        return this.$store.getters['auth/apiState'];
      },
      shopId() {
        return this.$store.getters['shopAuth/currentShopId'];
      },
    },
    methods: {
      async loginWithCredentials(cred) {
        this.loading = true;
        try {
          await this.$store.dispatch('auth/loginWithCredentials', {
            username: cred.mail,
            password: cred.password,
          });
          await this.$store.dispatch('auth/updateUser', {
            user: cred,
          });
          this.$mixpanel.track('Connexion utilisateur', {
            app_mb: process.env.VUE_APP_NAME,
            email: cred.mail,
          });
          await this.$router.push({ name: 'Dashboard' });
          this.showSuccessMessage();
        } catch (e) {
          this.showErrorMessage();
        }
        this.loading = false;
      },
      showSuccessMessage() {
        this.$message({
          type: 'success',
          message: `${this.$t('loginPage.successMessage')} ${this.$store.getters['auth/currentUser'].user.name}!`,
        });
      },
      showErrorMessage() {
        this.$message({
          type: 'error',
          message: this.$t('commons.defaultErrorMessage'),
        });
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '../../assets/css/main.styl';

  .login-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
